<template>
  <div>
    <div class="card top-draft" style="margin-bottom: 0px">
      <!-- <div class="col-lg-12 mg-top-1">
        <b-button variant="primary" @click="toCreate()">
          <i class="bx bx-plus font-size-16 align-middle me-2"></i>
          添加
        </b-button>
      </div> -->

      <div class="col-lg-12 list-header pad-header-bg clearfix">
        <div class="app-list-sort header-item-fix">
          <b-dropdown>
            <template v-slot:button-content>
              <sort-icon />
            </template>
            <b-dropdown-item
              v-for="(item, index) in sortList"
              :key="index"
              @click="listSort(item)"
            >
              <span class="pull-left" v-if="pageParams.sortBy == item.value">
                <i
                  v-if="pageParams.order == 'desc'"
                  class="bx bx-down-arrow-alt font-size-18 pull-left"
                ></i>
                <i
                  v-if="pageParams.order == 'asc'"
                  class="bx bx-up-arrow-alt font-size-18"
                ></i>
              </span>
              <span :class="{ padleft: pageParams.sortBy != item.value }">{{
                item.text
              }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="header-item-fix">
          <b-form-input
            size="sm"
            type="text"
            v-model="pageParams.contentKeyword"
            @keyup.enter.native="getList"
            placeholder="搜索标题"
          ></b-form-input>
          <b-button size="sm" variant="primary" @click="getList()">
            <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
            搜索
          </b-button>
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="resetParams()"
          >
            <i class="bx bx-revision font-size-16 align-middle"></i>
            重置
          </b-button>
        </div>
        <div class="header-item-fix">
          <b-form-select
            @change="getList()"
            v-model="pageParams.showState"
            class="form-select"
            :options="statusList"
            type="text"
          ></b-form-select>
        </div>
        <b-button class="btn-sm" variant="primary" @click="toCreate()">
          <i class="bx bx-plus font-size-16 align-middle me-2"></i>
          添加
        </b-button>
      </div>

      <div class="col-lg-12">
        <el-table
          v-loading="tableLoading"
          :data="items"
          style="width: 100%"
          :stripe="true"
          @selection-change="tableSelectionChange"
        >
          <el-table-column fixed="left" type="selection" align="center">
          </el-table-column>
          <el-table-column label="ID" prop="id" width="60" fixed="left">
          </el-table-column>
          <el-table-column label="标题" min-width="200" fixed="left">
            <template slot-scope="item">
              <div style="cursor: pointer" @click="showPre(item.row)">
                <show-repeat-title
                  v-if="repeatTitle"
                  :repeatTitle="repeatTitle"
                  :title="item.row.title"
                ></show-repeat-title>
                <span v-else>{{ item.row.title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="封面" width="80">
            <template slot-scope="item">
              <img
                v-if="item.row.image"
                class="w-3-rem"
                :src="`${item.row.image}`"
                alt
              />
              <img
                v-if="!item.row.image"
                class="w-3-rem"
                src="@/assets/images/image-null.jpg"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column label="媒体号" width="90">
            <template slot-scope="item">
              {{ item.row.username || "--" }}
            </template>
          </el-table-column>
          <el-table-column label="浏览量" width="80">
            <template slot-scope="item">
              <view-num :item="item.row"></view-num>
            </template>
          </el-table-column>
          <el-table-column label="评论" width="80">
            <template slot-scope="item">
              {{ item.row.commentNum || "0" }}
            </template>
          </el-table-column>
          <el-table-column label="角标" width="80">
            <template slot-scope="item">
              {{ item.row.subscript || "--" }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="item">
              <el-tooltip
                v-if="power['显示/隐藏']"
                :content="item.row.showState == 1 ? '点击隐藏' : '点击显示'"
              >
                <span
                  @click="batchHide(item.row)"
                  v-if="item.row.showState == 1"
                  :class="
                    isOverdue(item.row.publishedAt)
                      ? 'dsply-fix status-over'
                      : 'dsply-fix status-open'
                  "
                  ><i></i>显示</span
                >
                <span
                  @click="batchShow(item.row)"
                  v-if="item.row.showState == 0"
                  class="dsply-fix status-off"
                  ><i></i>隐藏</span
                >
              </el-tooltip>
              <div v-if="!power['显示/隐藏']">
                <span
                  v-if="item.row.showState == 1"
                  :class="
                    isOverdue(item.row.publishedAt)
                      ? 'dsply-fix status-over'
                      : 'dsply-fix status-open'
                  "
                  ><i></i>显示</span
                >
                <span
                  v-if="item.row.showState == 0"
                  class="dsply-fix status-off"
                  ><i></i>隐藏</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发稿人/创建时间" width="158">
            <template slot-scope="item">
              <div style="display: flex; flex-direction: column">
                <span>{{ item.row.creator || "--" }}</span>
                <span>{{ item.row.createdAt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="审核人/审核时间" width="158">
            <template slot-scope="item">
              <div style="display: flex; flex-direction: column">
                <span>{{ item.row.verifyName || "--" }}</span>
                <span>{{ item.row.verifiedAt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发布日期" width="158" prop="publishedAt">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="165">
            <template slot-scope="item">
              <div style="display: flex; flex-wrap: wrap">
                <div style="padding: 5px 0">
                  <button
                    v-if="item.row.showHistory"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toHistory(item.row)"
                  >
                    领取列表
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row, 'isModify')"
                    v-if="power['编辑信息']"
                  >
                    编辑信息
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row)"
                    v-if="power['编辑详情']"
                  >
                    编辑详情
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['评论']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toComments(item.row)"
                  >
                    评论
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <el-popover
                    @show="showQRcode(item.row)"
                    placement="bottom"
                    title="分享二维码"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <img :src="currentQRcode" />
                    </div>
                    <button
                      slot="reference"
                      v-if="power['查看']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="copyUrl(item.row)"
                    >
                      复制预览链接
                    </button>
                  </el-popover>
                </div>

                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                    v-if="power['移除']"
                  >
                    移除
                  </button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- :isBatch 如果有批量操作就传这个参数 没有就不传
        batchs 批量操作的列表 
        pageCallback 分页组件的回调方法 -->
        <pagination
          class="bath_r_20"
          :isBatch="true"
          :total="pageTotal"
          :batchs="batchs"
          :pageSize="pageParams.pageSize"
          :page.sync="pageParams.page"
          ref="page"
          @pageCallback="pageCallback"
        ></pagination>
      </div>
    </div>
    <el-drawer
      :visible.sync="drawer"
      :show-close="false"
      size="450px"
      @open="open()"
      @closed="closed()"
    >
      <iframe
        v-if="showIframe"
        ref="iframe"
        class="iframe-item"
        :src="rowData.previewUrl"
      ></iframe>
    </el-drawer>
    <app-list-loading ref="loading"></app-list-loading>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import content from "../../../server/api/videoPublish";
import { getPreLink, copyLink, getCopyLink, changeList } from "@/util/fun.js";
import ShowRepeatTitle from "@/components/ShowRepeatTitle.vue";

/**
 * Contacts-list component
 */
export default {
  components: {
    ShowRepeatTitle,
  },
  data() {
    return {
      showIframe: false,
      rowData: {},
      drawer: false,
      choiceListIds: [], //当前所选择的id
      pageParams: {
        page: 1,
        pageSize: 30,
        type: "2", //0:草稿，2：文章列表
        showState: "",
        contentKeyword: "",
        mediaId: "",
      },
      items: [],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        // { text: "显示", value: "1" },
        // { text: "隐藏", value: "2" },
      ],
      statusList: [
        { text: "筛选状态", value: "" },
        { text: "显示", value: "1" },
        { text: "隐藏", value: "0" },
      ],
      sortList: [
        { text: "阅读", value: "viewNum" },
        { text: "评论", value: "commentNum" },
        { text: "日期", value: "createTime" },
      ],
      power: "",
      tableLoading: false,
      currentQRcode: "",
      repeatTitle: "",
      pageTotal: 0,
    };
  },

  created() {
    this.pageParams.mediaId = JSON.parse(localStorage.chosedMedia).id;
    this.power = this.utils.currentPower("创作平台-视频发布");
    if (this.power["显示/隐藏"]) {
      this.batchs.push({ text: "显示", value: "1" });
      this.batchs.push({ text: "隐藏", value: "2" });
    }
    if (this.power["撤稿"]) {
      this.batchs.push({ text: "撤稿", value: "3" });
    }

    //从详情、评论返回文章列表时不重新调用列表接口
    let obj = this.getCache("video-list");
    if (obj.pageParams) {
      this.pageParams = obj.pageParams;
      if (obj.pageParams.contentKeyword) {
        this.repeatTitle = obj.pageParams.contentKeyword;
      }
    }
    if (obj && obj.list && obj.list[0]) {
      console.log("使用缓存");
      this.items = obj.list;
      this.pageTotal = obj.pageTotal;
      //从详情返回时更新列表数据
      obj = this.getCache("video-edit");
      console.log("获取的编辑缓存", obj);
      this.addCache("video-edit", "");
      if (obj && obj.id) {
        //检测编辑的文章id是否在本列表
        let judge = this.items.some((item) => {
          if (item.id == obj.id) {
            return true;
          }
        });
        //获取编辑的文章详情
        content.detail({ id: obj.id }).then((res) => {
          console.log("视频详情", res);
          let detail = res.data;
          if (detail.verifyState == 1) {
            if (judge) {
              //如果审核状态为通过且在本列表则更新对应数据
              this.items = this.items.map((item) => {
                if (item.id == obj.id) {
                  return { ...item, ...detail };
                } else {
                  return item;
                }
              });
              this.updateCache("video-list", {
                list: this.items,
              });
            } else {
              this.getList(false); //不显示加载图标更新列表
            }
          } else {
            //如果审核状态未通过但之前在本列表则删除对应数据
            if (judge) {
              this.pageTotal -= 1;
              this.items = changeList("delete", this.items, [detail.id], "id");
            }
          }
        });
      }
    } else {
      this.getList();
      this.addCache("video-edit", "");
    }
  },
  beforeDestroy() {
    this.addCache("video-list", {
      list: this.items,
      pageTotal: this.pageTotal,
      pageParams: this.pageParams,
    });
  },

  methods: {
    showPre(item) {
      this.rowData.previewUrl = getPreLink(item);
      this.drawer = true;
    },
    async showQRcode(item) {
      let url = getCopyLink(item);
      if (url) {
        this.currentQRcode = await this.$qrCode.toDataURL(url);
      }
    },
    copyUrl(item) {
      copyLink(getCopyLink(item), "链接");
    },
    closed() {
      this.showIframe = false;
    },
    open() {
      this.showIframe = true;
    },
    tableSelectionChange(selectValues) {
      this.choiceListIds = [];
      selectValues.map((val) => {
        this.choiceListIds.push(val.id);
      });
    },
    //获取列表数据
    getList(showLoading) {
      this.repeatTitle = this.pageParams.contentKeyword;
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      if (showLoading !== false) {
        this.tableLoading = true;
        this.items = [];
      }
      this.choiceListIds = [];
      content.videos(params).then((resp) => {
        if (resp.data) {
          this.tableLoading = false;
          if (resp.data.items) {
            resp.data.items.map((item) => {
              if (item.couponId) {
                item.showHistory = true;
              } else {
                if (item.redPacket && item.redPacket.id) {
                  item.showHistory = true;
                }
              }
            });
            this.items = resp.data.items;
            this.updateCache("video-list", {
              list: this.items,
            });
            this.pageTotal = resp.data.total || 0;
          }
        }
      });
    },

    toHistory(item) {
      if (item.couponId) {
        this.$router.push({
          name: "couponsReceive",
          query: { id: item.couponId },
        });
      } else {
        if (item.redPacket && item.redPacket.id) {
          let grantAmount =
            item.redPacket.totalAmount - item.redPacket.leftAmount;
          let redPacketData = {
            totalAmount: parseFloat(item.redPacket.totalAmount / 100).toFixed(
              2
            ), //总金额
            leftAmount: parseFloat(item.redPacket.leftAmount / 100).toFixed(2), //未发放金额
            grantAmount: parseFloat(grantAmount / 100).toFixed(2), //已发放金额
          };
          this.$router.push({
            name: "redPacketHistory",
            query: {
              redPacketId: item.redPacket.id,
              redPacketData: JSON.stringify(redPacketData),
            },
          });
        }
      }
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "batch") {
        if (this.choiceListIds.length < 1) {
          this.info("未选择内容");
          return;
        }
        //处理批量操作
        console.log(this.choiceListIds, "批量的id");
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击显示的处理方法
            this.batchShow();
          } else {
            Vue.swal("请选择要显示的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击隐藏的处理方法
            this.batchHide();
          } else {
            Vue.swal("请选择要隐藏的内容");
            return;
          }
        }
        if (obj.batch == 3) {
          if (this.choiceListIds.length) {
            //点击撤稿的处理方法
            this.batchRevert();
          } else {
            Vue.swal("请选择要撤稿的内容");
            return;
          }
        }
      }
    },

    //添加
    toCreate() {
      this.$router.push({
        name: "videoPublishDetail",
      });
    },

    //去编辑
    toDetail(item, isModify) {
      if (isModify) {
        this.$router.push({
          name: "videoPublishDetail",
          query: { id: item.id, isModify: true },
        });
      } else {
        this.$router.push({
          name: "videoPublishDetail",
          query: { id: item.id },
        });
      }
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.sortBy = "";
      this.pageParams.order = "";
      this.pageParams.showState = "";
      this.pageParams.contentKeyword = "";
      this.repeatTitle = "";
      this.getList();
    },

    // 排序
    listSort(item) {
      if (this.pageParams.sortBy == item.value) {
        this.pageParams.sortBy = item.value;
        if (this.pageParams.order == "asc") {
          this.pageParams.order = "desc";
        } else {
          this.pageParams.order = "asc";
        }
      } else {
        this.pageParams.sortBy = item.value;
        this.pageParams.order = "desc"; //默认倒序
      }
      this.getList();
    },

    batchHide(item) {
      Swal.fire({
        title: "确定隐藏?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "隐藏",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          content.hide(params).then((resp) => {
            if (resp.code === 0) {
              this.success("隐藏成功");
              // this.getList(); 修改状态成功不刷新列表，直接更改数据
              this.items = changeList(
                "changeAttribute",
                this.items,
                params.ids,
                {
                  showState: 0,
                }
              );
              if (!item) {
                this.choiceListIds = [];
              }
            } else {
              Vue.swal(resp.msg || "修改失败");
            }
          });
        }
      });
    },

    batchShow(item) {
      Swal.fire({
        title: "确定显示?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "显示",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          content.show(params).then((resp) => {
            if (resp.code === 0) {
              this.success("显示成功");
              // this.getList(); 修改状态后不调用列表接口，直接改数据
              this.items = changeList(
                "changeAttribute",
                this.items,
                params.ids,
                {
                  showState: 1,
                }
              );
              if (!item) {
                this.choiceListIds = [];
              }
            } else {
              Vue.swal(resp.msg || "修改失败");
            }
          });
        }
      });
    },

    batchRevert(item) {
      Swal.fire({
        title: "确定撤稿?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.ids = this.choiceListIds;
          content.revert(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "撤稿成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList(); 撤销成功直接更改列表数据
              if (this.items.length == params.ids.length) {
                this.getList();
              } else {
                this.pageTotal -= params.ids.length;
                this.items = changeList("delete", this.items, params.ids, "id");
                if (!item) {
                  this.choiceListIds = [];
                }
              }
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          content.remove(params).then((resp) => {
            if (resp.code === 0) {
              this.success("删除成功");
              // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
              if (this.items.length == params.ids.length) {
                this.getList();
              } else {
                this.pageTotal -= params.ids.length;
                this.items = changeList("delete", this.items, params.ids, "id");
                if (!item) {
                  this.choiceListIds = [];
                }
              }
            } else {
              this.warning(resp.msg || "删除失败");
            }
          });
        }
      });
    },
    toComments(item) {
      this.$router.push({
        name: "videoComments",
        query: { id: item.id },
      });
    },
  },
};
</script>
<style scoped>
.iframe-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
::v-deep .el-table thead .el-table__cell:first-child .cell {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:first-child .cell {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
::v-deep .el-table thead .el-table__cell:first-child .cell .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep
  .el-table
  tbody
  > .el-table__row
  .el-table__cell:first-child
  .cell
  .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep .el-table thead .el-table__cell:nth-child(2) .cell {
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:nth-child(2) .cell {
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:last-child .cell {
  padding-right: 0px !important;
}
</style>
